import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { CadastroBasicoNomeSituacaoForm } from '../components/CadastroBasicoNomeSituacaoForm';
import { getModalidadeAtendimento, cadastrarModalidadeAtendimento, alterarModalidadeAtendimento, excluirModalidadeAtendimento, } from './modalidades_atendimentos.service';
export var ModalidadesAtendimentosAlterar = function () {
    return (_jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.MODALIDADES_ATENDIMENTOS, paginaPermissao: FUNCIONALIDADES.MODALIDADES_ATENDIMENTOS, rota: ROUTES.MODALIDADES_ATENDIMENTOS, services: {
            getItem: getModalidadeAtendimento,
            cadastrarItem: cadastrarModalidadeAtendimento,
            alterarItem: alterarModalidadeAtendimento,
            excluirItem: excluirModalidadeAtendimento,
        } }));
};
export default ModalidadesAtendimentosAlterar;
